/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { Int32GenericApiResponseFromJSON, ProtocolDtoGenericApiResponseFromJSON, ProtocolHtmlRequestToJSON, ProtocolRequestToJSON, ProtocolSearchResultDtoListGenericApiResponseFromJSON, StringGenericApiResponseFromJSON, StringListGenericApiResponseFromJSON, } from '../models';
/**
 *
 */
export class AcceptanceReportApi extends runtime.BaseAPI {
    /**
     */
    apiAcceptanceReportGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.createdFrom !== undefined) {
                queryParameters['CreatedFrom'] = requestParameters.createdFrom.toISOString();
            }
            if (requestParameters.createdTo !== undefined) {
                queryParameters['CreatedTo'] = requestParameters.createdTo.toISOString();
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/AcceptanceReport`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ProtocolSearchResultDtoListGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiAcceptanceReportGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiAcceptanceReportGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiAcceptanceReportPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/AcceptanceReport`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ProtocolRequestToJSON(requestParameters.protocolRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => Int32GenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiAcceptanceReportPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiAcceptanceReportPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiAcceptanceReportRecreatepdfPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.protocolId !== undefined) {
                queryParameters['protocolId'] = requestParameters.protocolId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/AcceptanceReport/recreatepdf`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => StringGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiAcceptanceReportRecreatepdfPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiAcceptanceReportRecreatepdfPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiAcceptanceReportSendmailPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.protocolId !== undefined) {
                queryParameters['protocolId'] = requestParameters.protocolId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/AcceptanceReport/sendmail`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => StringListGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiAcceptanceReportSendmailPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiAcceptanceReportSendmailPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiAcceptanceReportUpdatefilePostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.protocolId !== undefined) {
                formParams.append('ProtocolId', requestParameters.protocolId);
            }
            if (requestParameters.documentFile !== undefined) {
                formParams.append('DocumentFile', requestParameters.documentFile);
            }
            if (requestParameters.overwrite !== undefined) {
                formParams.append('Overwrite', requestParameters.overwrite);
            }
            const response = yield this.request({
                path: `/api/AcceptanceReport/updatefile`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => StringGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiAcceptanceReportUpdatefilePost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiAcceptanceReportUpdatefilePostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiAcceptanceReportUpdatehtmlPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/AcceptanceReport/updatehtml`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ProtocolHtmlRequestToJSON(requestParameters.protocolHtmlRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => StringGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiAcceptanceReportUpdatehtmlPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiAcceptanceReportUpdatehtmlPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    getProtocolByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getProtocolById.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/AcceptanceReport/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ProtocolDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    getProtocolById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getProtocolByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    getProtocolHtmlByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getProtocolHtmlById.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/AcceptanceReport/gethtml/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => StringGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    getProtocolHtmlById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getProtocolHtmlByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
